export default __webpack_public_path__ + "static/media/mo-complex-layout-12-3@2x.dbed278b.png";